import {
  Menu,
  MenuItemLink,
  useResourceDefinitions,
  useSidebarState,
} from "react-admin";
import DashboardIcon from "@mui/icons-material/Dashboard";
import HomeIcon from "@mui/icons-material/Home";
import { ListSubheader } from "@mui/material";
import { useRole } from "@/hooks/userRole";
import useStyles from "./style";

const roleMenuItems: Record<string, string[]> = {
  admin: ["entities", "users", "vouchers"],
  entity: ["entitieslocation", "vouchers", "cashier"],
  cashier: ["vouchers"],
};

const roleMenuVoucher: Record<string, string[]> = {
  entity: ["giftcards", "productsoffered", "bogo", "discount"],
};

const roleMenuHeaders: Record<string, string[]> = {
  admin: ["Comptes"],
  entity: ["Création", "Gestion"],
  cashier: ["Informations"],
};

const CustomMenu = () => {
  const classes = useStyles();
  const { role } = useRole();
  const [open] = useSidebarState();
  const resources = useResourceDefinitions();
  const items = role ? roleMenuItems[role] || [] : [];
  const headers = role ? roleMenuHeaders[role] || [] : [];
  const vouchers = role ? roleMenuVoucher[role] || [] : [];
  const isAdmin = role === "admin";
  const isEntity = role === "entity";

  if (!open || !role) return null;

  return (
    <Menu className={classes.menu}>
      {isAdmin && (
        <MenuItemLink
          to="/"
          primaryText="Accueil"
          leftIcon={<HomeIcon />}
          className={classes.menuItem}
        />
      )}

      <MenuItemLink
        to={isAdmin ? "/dashboard" : "/"}
        primaryText="Dashboard"
        leftIcon={<DashboardIcon />}
        className={classes.menuItem}
      />

      {isEntity && headers[0] && (
        <ListSubheader component="div">{headers[0]}</ListSubheader>
      )}

      {isEntity &&
        vouchers.map((name) => {
          const resource = resources[name];

          return (
            <MenuItemLink
              key={name}
              to={`/${name}/create`}
              primaryText={resource?.options?.label ?? name}
              leftIcon={resource?.icon ? <resource.icon /> : undefined}
              className={classes.menuItem}
            />
          );
        })}

      <ListSubheader component="div">
        {isEntity ? headers[1] : headers[0]}
      </ListSubheader>

      {items.map((name) => {
        const resource = resources[name];

        return (
          <MenuItemLink
            key={name}
            to={`/${name}`}
            primaryText={resource?.options?.label ?? name}
            leftIcon={resource?.icon ? <resource.icon /> : undefined}
            className={classes.menuItem}
          />
        );
      })}
    </Menu>
  );
};

export default CustomMenu;
